import { useTranslation } from "react-i18next";
import { useConfirm } from "../../context/ConfirmContext";
import { goToCourse } from "../../api/";
import { openCourseWithLoader } from "./openCourseWithLoader";

export const useMoodleCourseOpener = () => {
  const { t } = useTranslation();
  const dialog = useConfirm();

  const openCourse = async (courseId: number, userId: number, courseName: string) => {
    await openCourseWithLoader({
      courseId,
      userId,
      courseName,
      goToCourse,
      t,
      onError: (title, message) => dialog.notification(title, message),
    });
  };

  return openCourse;
};
